export enum EntityFeature {
	HasActivity = 'HasActivity',
	HasAuditor = 'HasAuditor',
	HasAuditorRef = 'HasAuditorRef',
	HasCode = 'HasCode',
	HasCustomer = 'HasCustomer',
	HasDisplayOrder = 'HasDisplayOrder',
	HasEntityRef = 'HasEntityRef',
	HasLabels = 'HasLabels',
	HasMetadata = 'HasMetadata',
	HasNotes = 'HasNotes',
	HasOwnerRef = 'HasOwnerRef',
	HasSid = 'HasSid',
	HasSlug = 'HasSlug',
	HasStateStatus = 'HasStateStatus',
	HasTags = 'HasTags',
	HasTid = 'HasTid',
	HasTitleDescription = 'HasTitleDescription',
	HasUSCC = 'HasUSCC',
	HasVendorRef = 'HasVendorRef',
	IsUser = 'IsUser',
	IsCustomer = 'IsCustomer',
	IsActivity = 'IsActivity',
	IsOwner = 'IsOwner',
	IsState = 'IsState',
	IsStatus = 'IsStatus',
	IsType = 'IsType',
	IsSystemType = 'IsSystemType',
	IsTenantType = 'IsTenantType',
	IsHierarchy = 'IsHierarchy',
	IsRelation = 'IsRelation',
	IsLabel = 'IsLabel',
}

export type EntityFeatureCode = keyof typeof EntityFeature;
